import { call, put } from "redux-saga/effects";
import { push } from "react-router-redux";
import browserHistory from "react-router";
import cookie from "react-cookies";
import {
  getRegisterResponse,
  setCurrentUser,
  getCurrentUser,
  setUserPermissions,
} from "../../slices/user/userSlice";
//import { push } from "connected-react-router";
import {
  requestLogInUser,
  requestGetCurrentUser,
  requestRegisterUser,
} from "../requests/user";
import Swal from "sweetalert2";
import "animate.css";
import {getAuthorization} from "../../../axios/AxiosAut";

export function* handleLogInUser(action) {
  try {
    const res = yield call(requestLogInUser, action.payload);
    localStorage.setItem('token',res.data.access_token)

    yield cookie.save("access_token", res.data.access_token, { path: "/" });
    yield cookie.save("refresh_token", res.data.refresh_token, { path: "/" });
    // yield call(handleGetCurrentUser);
    // yield put(setCurrentUser(res));
    // yield put(push("/register"));
    // // yield put(getCurrentUser(res.data));
    // if (res.data.member.is_owner) {
    //   yield action.payload.navigate("/dashboard");
    // } else {
    yield action.payload.navigate("/account-registeration");
    console.log("res", res.data);
    Swal.fire({
      position: "top-end",
      title: "Successfully Logged In!",
      showConfirmButton: false,
      timer: 3500,
      showClass: {
        popup: "animate__animated animate__fadeInRight",
      },
      hideClass: {
        popup: "animate__animated animate__fadeOutRight",
      },
      width: 300,
      color: "#FFFFFF",
      background: "#2A91D7",
      backdrop: `rgba(0,0,0,0)`,
    });
    yield action.payload.setPermissions();
  } catch (error) {
    console.log(error);
    Swal.fire({
      title: "Oops...",
      text: "Something went wrong try again login",
      icon: "warning",
      timer: 3000,
      showConfirmButton: false,
      showClass: {
        popup: "animate__animated animate__fadeInDown",
      },
      hideClass: {
        popup: "animate__animated animate__fadeOutUp",
      },
    });
    yield action.payload.onSubmitProps.setSubmitting(false);
  }
}

export function* handleGetCurrentUser() {
  try {
    const response = yield call(requestGetCurrentUser);
    const { data } = response;
    yield put(setCurrentUser({ ...data }));
  } catch (error) {
    console.log(error);
  }
}

// export function* handleSetCurrentUser(data) {
//   try {
//     yield put(setCurrentUser({ data }));
//   } catch (error) {}
// }

export function* handleRegisterUser(action) {
  try {
    const res = yield call(requestRegisterUser, action.payload);
    //console.log("api hitted ", res);
    yield put(getRegisterResponse(res.data));
    yield action.payload.navigate("/login");
    Swal.fire({
      title: "Verification Required",
      text: "Thank you for registering your account. Verification email has been send to your email",
      icon: "info",
      timer: 3000,
      showConfirmButton: false,
      showClass: {
        popup: "animate__animated animate__fadeInDown",
      },
      hideClass: {
        popup: "animate__animated animate__fadeOutUp",
      },
    });
  } catch (error) {
    console.log(error);
    yield action.payload.onSubmitProps.setSubmitting(false);
    Swal.fire({
      title: "Oops...",
      text: "Something went wrong try again",
      icon: "warning",
      timer: 3000,
      showConfirmButton: false,
      showClass: {
        popup: "animate__animated animate__fadeInDown",
      },
      hideClass: {
        popup: "animate__animated animate__fadeOutUp",
      },
    });
  }
}
